<template>
  <div class="maxwidht">
    <div class="header-container">
      <div @click="closeLogin">
        <img src="../assets/close.png" />
      </div>
      <div class="register" @click="register">注册账号</div>
    </div>
    <div class="login-container">
      <div class="login-box">
        <h2>密码登录</h2>
        <p>输入账号和密码验证后登录</p>
        <div class="login-area">
          <div>
            <input type="text" placeholder="请输入账号" v-model="account" />
            <input type="password" placeholder="请输入密码" v-model="password" />
          </div>
          <button class="login_btn" @click="loginAccount">登录</button>
        </div>
        <div class="checkbox-container">
          <!-- <button class="forget_btn">修改密码</button> -->
        </div>


      </div>
      <div class="flex agreement">
        <div>
          <div class="flex">
            <div class="smallsize" @click="agreement">《用户协议》</div>
            <div class="smallsize" @click="privacy">《隐私协议》</div>
          </div>
          <div>
            <p class="icp" v-html="ICPhtml"></p>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {
  login,
  register
} from "../utils/api"
export default {
  data() {
    return {
      account: '',
      password: '',
      ICPhtml:'Copyright © 2021-2024 聚创(邯郸)文化传媒有限公司 ICP备案号：<a href="https://beian.miit.gov.cn/?wm=vt1">冀ICP备20011305号-3</a>',
      agreed: false
    };
  },
  created() {
    var domain = window.location.hostname;
    if(domain=='wl.bjczjy.cn'){
      this.ICPhtml = 'Copyright © 2021-2024 邯郸传正文化发展有限公司 ICP备案号：<a href="https://beian.miit.gov.cn/?wm=vt1">冀ICP备19032043号-3</a>'
    }
  },
  methods: {
    closeLogin() {
      this.$router.replace({
        path: '/my'
      })
    },
    //账号注册
    register() {
      this.$router.push({
        name: 'register'
      })
    },
    loginAccount() {
      let params = {
        account: this.account,
        password: this.password,
        scene: '1',
        terminal: '3'
      }
      login(params).then(res => {
        let user = {
          avatar: res.data.avatar,
          mobile: res.data.mobile,
          nickname: res.data.nickname,
          sn: res.data.sn,
        }
        let token = res.data.token;
        this.$store.dispatch('login', { user, token });
        this.$router.replace({
          path: '/my'
        })
      })
    },
    agreement() {
      this.$router.push({
        name: 'agreement'
      })
    },
    privacy() {
      this.$router.push({
        name: 'privacy'
      })
    }
  },
};
</script>

<style scoped>
.maxwidht {
  max-width: 500px;
  height: 100vh;
  margin: 0 auto;
  background-image: url('../assets/loginbg.png');
  display: flex;
  flex-direction: column;
}

.login-container {
  padding: 20px;
  display: flex;
  flex: 1;
  flex-direction: column;
}

.agreement {
  flex: 1;
  align-items: flex-end;

}

.flex {
  display: flex;
  justify-content: center;
}

.smallsize {
  font-size: 14px;
  color: #888;
  width: 100%;
  text-align: center;
}

.login-box {}

.login-area {
  padding: 20px 20px;
}

h2 {

  margin-bottom: 10px;
}

p {
  color: #888;
  font-size: 14px;
  margin-bottom: 20px;
}

input {
  width: 93%;
  display: block;
  padding: 10px;
  margin: 10px 0;
  border-radius: 5px;
  border: 1px solid #ddd;
  font-size: 14px;
}

.agreement-input {
  width: fit-content !important;
}

.login_btn {
  width: 100%;
  padding: 10px;
  background-color: #ea5f5a;
  border: none;
  border-radius: 5px;
  color: white;
  font-size: 16px;
  cursor: pointer;
  margin-top: 10px;
}

.forget_btn {
  border: none;
  background: none;
  color: #0f77ff;
}

.checkbox-container {
  display: flex;
  align-items: center;
  margin-top: 10px;
  padding: 0 20px;
}

label {
  font-size: 12px;
  color: #888;
  margin-left: 5px;
}

a {
  color: #888;
  text-decoration: underline;
  margin-left: 5px;
}

.icp {
  font-size: 12px;
  color: #aaa;
  margin-top: 20px;
  text-align: center;
}

.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px;
}

.header-container img {
  width: 30px;
}

.header-container .register {
  font-size: 18px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue